import {AbstractModel} from './abstract-model';
import {Document} from './document';

export class Advertiser extends AbstractModel {
  id: number | null = null;
  companyName: string | null = null;
  firstname: string | null = null;
  lastname: string | null = null;
  nickname: string | null = null;
  address: string | null = null;
  zipCode: string | null = null;
  state: string | null = null;
  city: string | null = null;
  country: string | null = null;
  phoneNumber: string | null = null;
  email: string | null = null;
  websiteUrl: string | null = null;
  companyNumber: string | null = null;
  vatNumber: string | null = null;
  status: string | null = null;
  logo: Document | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.logo) {
      this.logo = new Document().deserialize(input.logo);
    }

    return this;
  }

  getContactName(): string {
    let name = (this.firstname ?? '') + ' ' + (this.lastname ?? '');
    return name.trim();
  }

  getStatusName(): string | null {
    switch (this.status) {
      case 'active':
        return 'Active';
      case 'inactive':
        return 'Inactive';
    }

    return null;
  }

  getStatusClass(): string | null {
    switch (this.status) {
      case 'active':
        return 'bg-success';
      case 'inactive':
        return 'bg-danger';
    }

    return null;
  }

  override toString(): string {
    return this.companyName ?? '';
  }
}
